import { render } from "./Header.vue?vue&type=template&id=1921f16e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=1921f16e&scoped=true&lang=scss"
import "./Header.vue?vue&type=style&index=1&id=1921f16e&lang=scss"
script.render = render
script.__scopeId = "data-v-1921f16e"

export default script